import { Checkbox, Inline } from '@etg/wings';
import { css } from '@eti/styles';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const checkboxLabelStyles = css`
  cursor: pointer;
`;
const ApplySelectionToAllCheckbox = ({
  productName,
  firstTravelerSelectionValue,
  shouldApplySelectionToAll,
  onChangeAll,
  label
}) => {
  return /*#__PURE__*/_jsxs(Inline, {
    align: "start",
    "data-testid": `${productName}-applyToAllCheckbox`,
    noWrap: true,
    spacing: 8,
    children: [/*#__PURE__*/_jsx(Checkbox, {
      checked: shouldApplySelectionToAll,
      "data-testid": `${productName}-applySelectionToAll-input`,
      id: `${productName}-applySelectionToAll-input`,
      name: `${productName}-applySelectionToAll`,
      onChange: event => onChangeAll(event.target.checked, firstTravelerSelectionValue)
    }), /*#__PURE__*/_jsx("label", {
      className: checkboxLabelStyles,
      "data-testid": `${productName}-applySelectionToAll-label`,
      htmlFor: `${productName}-applySelectionToAll-input`,
      children: label
    })]
  });
};
export default ApplySelectionToAllCheckbox;
//# sourceMappingURL=ApplySelectionToAllCheckbox.js.map